export const REQUESTS_ACTIONS = {
    SET_REQUESTS: "SET_REQUESTS",
    SET_IS_LOADING: "SET_IS_LOADING",
}